<template>
	<Dropdown
		labelText="Vehicle Type"
		:options="options"
		v-model="currentValue"
		@change="onChange"
		@input="onChange"
	/>
</template>

<script>
import Dropdown from '@/components/forms/dropdown/dropdown.vue';

export default {
	name: 'VehicleTypesDropdown',
	components: {
		Dropdown
	},
	data() {
		return {
			options: [
				{
					text: 'Passenger',
					value: 'P'
				},
				{
					text: 'Motorcycle',
					value: 'MC'
				},
				{
					text: 'Off Highway',
					value: 'OH'
				},
				{
					text: 'Truck (Pick-Up or Commercial)',
					value: 'TR'
				},
				{
					text: 'Travel Trailer',
					value: 'TT'
				},
				{
					text: 'Vehicle Trailer',
					value: 'VT'
				},
				{
					text: 'Tools',
					value: 'TO'
				},
				{
					text: 'Vessel',
					value: 'VS'
				}
			],
			currentValue: undefined
		};
	},
	props: {
		value: {
			type: String,
			default: 'P'
		}
	},
	created() {
		this.currentValue = this.value;
	},
	methods: {
		onChange() {
			this.$emit('change', this.currentValue);
			this.$emit('input', this.currentValue);
		}
	}
};
</script>

<style lang="scss" scoped></style>
